module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/fonts/material-design-icons/MaterialIcons-Regular.woff
// module id = ../../../../../src/assets/fonts/material-design-icons/MaterialIcons-Regular.woff
// module chunks = 0